export type MediaType = "movie" | "tv";

export interface Movie {
  id: string;
  title: string;
  type: MediaType;
  region: string;
  year: number;
  genres: string[];
  director: string;
  cast: string[];
  duration: string;
  rating: number;
  cover: string;
  backdrop: string;
  summary: string;
  synopsis: string;
  tags: string[];
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "m001",
    title: "星海回响",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    genres: ["科幻", "剧情"],
    director: "顾南舟",
    cast: ["沈亦舟", "林芷夏", "陈默声"],
    duration: "132分钟",
    rating: 9.1,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20against%20a%20deep%20blue%20nebula%2C%20cinematic%20digital%20art%2C%20glowing%20orange%20highlights%2C%20minimalist%20composition%2C%20dark%20navy%20background%2C%20no%20text&width=600&height=900&seq=fly-cover-001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sweeping%20cinematic%20wide%20shot%20of%20deep%20space%20nebula%20in%20dark%20blue%20and%20orange%2C%20tiny%20spacecraft%20trail%2C%20atmospheric%20science%20fiction%20concept%20art%2C%20moody%20lighting%2C%20high%20detail&width=1600&height=900&seq=fly-back-001&orientation=landscape",
    summary: "一名深空信号员在孤独的漂流中，收到了一段来自故乡、却迟到了四十年的回响。",
    synopsis:
      "公元2147年，人类在木卫二的轨道上建立了第一座深空信号站。信号员周行独自值守，日复一日地监听着宇宙深处的杂音。某天，一段带着旧时代编码格式的信号闯入了他的频道——那是四十年前，他母亲在地球上录下的一段私人留言。信号穿越了漫长的星海，抵达时母亲早已不在人世。周行决定违背规程，将信号站的天线对准信号来向，用尽全部储备电力，只为给这段回响发出一个回答。",
    tags: ["深空", "孤独", "亲情", "时间"],
    featured: true,
  },
  {
    id: "m002",
    title: "雾都迷踪",
    type: "movie",
    region: "英国",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    director: "艾德里安·科尔",
    cast: ["奥斯卡·雷恩", "克拉拉·贝文"],
    duration: "118分钟",
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20mystery%20movie%20poster%20of%20a%20foggy%20london%20street%20lamp%20and%20a%20lone%20coat%20silhouette%2C%20dark%20blue%20tones%20with%20orange%20glow%2C%20cinematic%20digital%20art%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20foggy%20city%20alley%20at%20night%20in%20deep%20blue%20tone%20with%20warm%20orange%20street%20lamp%2C%20cinematic%20mystery%20scene%2C%20rain%20reflections%2C%20atmospheric&width=1600&height=900&seq=fly-back-002&orientation=landscape",
    summary: "一起尘封二十年的旧案，在浓雾再次笼罩的那天重新开口说话。",
    synopsis:
      "伦敦的冬天，雾总是先于记忆抵达。退休探员哈罗德被一封信重新拉回了他此生最不愿面对的案子——1998年的“雾夜失踪案”。当年唯一的目击者如今已经失忆，而新出现的证据却指向了一个不该存在的人。哈罗德拖着病体，在能见度不足十米的街道间穿行，一步步拼凑出被时间掩埋的真相。当浓雾散去，他发现自己要找的人，一直都在离他最近的地方。",
    tags: ["悬疑", "旧案", "雾", "记忆"],
    featured: true,
  },
  {
    id: "m003",
    title: "南国旧事",
    type: "movie",
    region: "中国香港",
    year: 2025,
    genres: ["剧情", "文艺"],
    director: "苏曼青",
    cast: ["何芷宁", "梁叙白"],
    duration: "104分钟",
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20literary%20drama%20movie%20poster%20of%20an%20old%20southern%20town%20street%20with%20warm%20afternoon%20light%2C%20deep%20blue%20shadow%20and%20amber%20highlights%2C%20cinematic%20painting%20style%2C%20no%20text&width=600&height=900&seq=fly-cover-003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=nostalgic%20southern%20chinese%20old%20town%20at%20golden%20hour%2C%20lanterns%20and%20tiled%20roofs%2C%20deep%20blue%20evening%20shadows%20with%20warm%20amber%20light%2C%20cinematic%20painting&width=1600&height=900&seq=fly-back-003&orientation=landscape",
    summary: "一座即将拆迁的南国小城，承载着两代人没有被说出口的和解。",
    synopsis:
      "离家十五年的建筑师阿宁回到南国小城，只为签下老宅的拆迁同意书。她本以为这只是一趟三天的行程，却在翻找旧物时，重新读到了母亲从未寄出的信。小城的巷子、糖水铺、骑楼下的旧自行车，都在提醒她那些被她刻意遗忘的往事。随着拆迁日期临近，阿宁必须在推土机到来之前，决定是继续逃离，还是让这座城和这段关系都得到一次迟来的告别。",
    tags: ["故乡", "和解", "离别", "文艺"],
    featured: true,
  },
  {
    id: "m004",
    title: "铁轨上的春天",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "爱情"],
    director: "周牧野",
    cast: ["许知遥", "陆川行"],
    duration: "121分钟",
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20romance%20drama%20movie%20poster%20of%20a%20train%20crossing%20a%20spring%20field%2C%20deep%20blue%20sky%20and%20orange%20sunset%2C%20cinematic%20digital%20painting%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20lone%20train%20traveling%20across%20endless%20spring%20fields%20under%20a%20deep%20blue%20dusk%20sky%20with%20orange%20sunset%20glow%2C%20cinematic%20landscape%20painting&width=1600&height=900&seq=fly-back-004&orientation=landscape",
    summary: "两个在绿皮火车上相遇的陌生人，用一站又一站的旅途，换来了一个春天。",
    synopsis:
      "绿皮火车缓慢地穿过中国北方的原野。失意的音乐人顾辞买了一张没有终点的车票，只想让铁轨声盖过心里的噪音。邻座的女孩春迟带着一箱旧书，要去见一个她从未谋面的笔友。两人从沉默到交谈，从争执到约定，在每一个停靠的小站留下一点点痕迹。当火车终于抵达终点，他们才发现，真正想要去的地方，是彼此愿意停留的那个春天。",
    tags: ["火车", "旅途", "相遇", "治愈"],
    featured: false,
  },
  {
    id: "m005",
    title: "深潜者",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    genres: ["动作", "科幻"],
    director: "韩劲松",
    cast: ["方撼", "温雨桐", "卓远"],
    duration: "126分钟",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20action%20sci-fi%20poster%20of%20a%20diver%20descending%20into%20dark%20deep%20sea%20with%20glowing%20orange%20lights%2C%20deep%20blue%20underwater%2C%20cinematic%20digital%20art%2C%20no%20text&width=600&height=900&seq=fly-cover-005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20a%20submersible%20descending%2C%20dark%20blue%20water%20and%20glowing%20orange%20bioluminescence%2C%20cinematic%20underwater%20concept%20art&width=1600&height=900&seq=fly-back-005&orientation=landscape",
    summary: "当深海勘探队触碰到那条不该存在的裂缝，所有人的氧气都在倒计时。",
    synopsis:
      "一支由精英潜水员组成的深海勘探队，奉命前往马里亚纳海沟下方一条新发现的地质裂缝。队长沈岸知道这次任务远比简报上写的危险，但没人预料到裂缝深处传来的低频震动，会让所有设备同时失灵。氧气、电力、通讯全部告急，队员之间开始出现分歧。沈岸必须在黑暗与压力中做出选择：是带着全部人赌一个生还的可能，还是牺牲一部分人保全另一些。",
    tags: ["深海", "极限", "团队", "生存"],
    featured: true,
  },
  {
    id: "m006",
    title: "第七个冬天",
    type: "movie",
    region: "韩国",
    year: 2025,
    genres: ["悬疑", "剧情"],
    director: "郑河允",
    cast: ["李瑞峻", "崔恩书"],
    duration: "113分钟",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20suspense%20poster%20of%20a%20snowy%20village%20window%20with%20a%20lone%20silhouette%2C%20cold%20deep%20blue%20tones%20with%20warm%20orange%20lamplight%2C%20cinematic%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=quiet%20snowy%20mountain%20village%20at%20dusk%2C%20deep%20blue%20snow%20with%20warm%20orange%20window%20lights%2C%20cinematic%20winter%20atmosphere&width=1600&height=900&seq=fly-back-006&orientation=landscape",
    summary: "雪村的第七个冬天，失踪的人终于回来了，却没有人愿意承认认识他。",
    synopsis:
      "偏远雪村每年冬天都会下一场没有尽头的大雪。七年前的冬天，少年姜河在同一场雪里失踪，从此杳无音信。第七个冬天，一个自称姜河的年轻人出现在村口，容貌未改，记忆却像被雪覆盖了一样残缺。村里的人一个接一个否认认识他，包括他曾经的挚友。为了找回自己的名字，姜河必须在一个所有人都选择遗忘的地方，重新证明自己曾经存在过。",
    tags: ["雪村", "失踪", "记忆", "身份"],
    featured: false,
  },
  {
    id: "m007",
    title: "山城理发店",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["喜剧", "剧情"],
    director: "老石",
    cast: ["秦万山", "罗小满", "丁胖子"],
    duration: "98分钟",
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20warm%20comedy%20movie%20poster%20of%20a%20small%20barbershop%20in%20a%20mountain%20city%2C%20deep%20blue%20evening%20tone%20with%20orange%20interior%20light%2C%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=fly-cover-007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20cozy%20tiny%20barbershop%20on%20a%20steep%20mountain%20city%20street%20at%20night%2C%20deep%20blue%20hills%20and%20warm%20orange%20shop%20light%2C%20cinematic%20illustration&width=1600&height=900&seq=fly-back-007&orientation=landscape",
    summary: "山城最老的理发店里，一把剪刀剪走了三十年的人间烟火。",
    synopsis:
      "秦师傅的山城理发店开在半山腰的台阶旁，三十年来只收五块钱剪一次头。街坊的大事小情都在这里发生：谁家孩子考上了大学，谁的媳妇跟人跑了，谁又偷偷在门口哭过。当拆迁告示贴上墙，秦师傅决定在关门前，给每一位老顾客再剪一次头。剪刀起落之间，那些被生活磨平的故事，重新在山城的雾里活了过来。",
    tags: ["市井", "温情", "告别", "烟火气"],
    featured: false,
  },
  {
    id: "m008",
    title: "荒原列车",
    type: "movie",
    region: "美国",
    year: 2025,
    genres: ["冒险", "西部"],
    director: "卢卡斯·格兰特",
    cast: ["杰克·莫里森", "艾拉·维恩"],
    duration: "137分钟",
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20western%20adventure%20poster%20of%20a%20steam%20train%20crossing%20a%20vast%20desert%20under%20dark%20blue%20sky%20with%20orange%20dust%20haze%2C%20cinematic%20painting%2C%20no%20text&width=600&height=900&seq=fly-cover-008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vintage%20steam%20train%20crossing%20a%20vast%20desert%20plain%20at%20sunset%2C%20deep%20blue%20sky%20with%20orange%20dust%20glow%2C%20cinematic%20western%20landscape&width=1600&height=900&seq=fly-back-008&orientation=landscape",
    summary: "一列穿越荒原的火车上，每个乘客都在隐藏一个不能说的目的地。",
    synopsis:
      "横穿北美荒原的“曙光号”列车上，乘客寥寥，每个人都带着自己的秘密。一个假装成商人的赏金猎人，一个抱着骨灰盒的老妇人，一个不会说话的孩子，还有一个始终没有露面的行李主人。当列车在无人区因为故障停下，车上的人被迫面对彼此。荒原的夜里没有法律，只有站得住的人才能决定明天谁来开车。",
    tags: ["列车", "荒原", "冒险", "秘密"],
    featured: false,
  },
  {
    id: "t001",
    title: "长夜将尽",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["悬疑", "犯罪"],
    director: "程斯年",
    cast: ["傅沉", "纪云舒", "邵野"],
    duration: "全24集",
    rating: 9.0,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20crime%20drama%20series%20poster%20of%20a%20city%20skyline%20at%20deep%20blue%20night%20with%20orange%20neon%20reflections%2C%20cinematic%20minimalist%20digital%20art%2C%20no%20text&width=600&height=900&seq=fly-cover-009&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20city%20skyline%20at%20night%20in%20deep%20blue%20tones%20with%20orange%20neon%20reflections%20on%20wet%20streets%2C%20cinematic%20crime%20drama%20atmosphere&width=1600&height=900&seq=fly-back-009&orientation=landscape",
    summary: "刑警与嫌犯，在漫长的一夜里互相审讯，也互相拯救。",
    synopsis:
      "凌晨两点，刑警纪云舒接手了一起没有尸体的命案。唯一的嫌疑人坐在审讯室里，态度平静得反常。接下来的十二个小时里，两人展开了一场没有硝烟的心理博弈。随着供词的层层反转，纪云舒逐渐发现，眼前这个男人可能既是凶手，也是另一个案件的受害者。天亮之前，她必须在真相与正义之间，做出一个可能会毁掉两个人的选择。",
    tags: ["刑侦", "审讯", "悬念", "人性"],
    featured: true,
  },
  {
    id: "t002",
    title: "潮汐之下",
    type: "tv",
    region: "中国大陆",
    year: 2025,
    genres: ["剧情", "家庭"],
    director: "柳如岚",
    cast: ["宋晚", "陆承宇", "安雯"],
    duration: "全36集",
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20family%20drama%20series%20poster%20of%20a%20seaside%20town%20at%20dusk%2C%20deep%20blue%20sea%20and%20orange%20horizon%2C%20cinematic%20painting%2C%20no%20text&width=600&height=900&seq=fly-cover-010&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20quiet%20seaside%20town%20harbor%20at%20dusk%2C%20deep%20blue%20ocean%20and%20orange%20sky%2C%20cinematic%20drama%20landscape&width=1600&height=900&seq=fly-back-010&orientation=landscape",
    summary: "渔港小镇的三代女人，用各自的沉默对抗着潮水的涨落。",
    synopsis:
      "沿海小镇的潮水每天涨落两次，就像这个家里三代女人之间的沉默，来来去去却从不被打破。外婆守着一间快要关门的海产铺，母亲在外地做了大半辈子工，年轻的外孙女带着一个不愿提起的过去回到这里。随着一场台风逼近，被压抑多年的秘密不得不被翻出来。她们必须学会在潮水退去之后，重新面对彼此。",
    tags: ["家庭", "三代", "海边", "和解"],
    featured: true,
  },
  {
    id: "t003",
    title: "九号档案馆",
    type: "tv",
    region: "日本",
    year: 2025,
    genres: ["悬疑", "奇幻"],
    director: "宫岛彻",
    cast: ["高桥铃", "白石匠"],
    duration: "全12集",
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20mystery%20series%20poster%20of%20a%20dim%20archive%20room%20with%20glowing%20files%2C%20deep%20blue%20tones%20with%20orange%20lamp%20light%2C%20cinematic%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vast%20dim%20archive%20hall%20filled%20with%20endless%20filing%20cabinets%2C%20deep%20blue%20darkness%20with%20warm%20orange%20lamps%2C%20cinematic%20mystery%20interior&width=1600&height=900&seq=fly-back-011&orientation=landscape",
    summary: "一间只收录“未发生之事”的档案馆，每个抽屉都通向另一种可能。",
    synopsis:
      "在一栋废弃大楼的地下九层，藏着一间没有出现在任何地图上的档案馆。管理员白石的工作，是整理那些“本来可能发生、却终究没有发生”的事情的卷宗。新来的实习生高桥铃起初以为这只是某种离奇的档案分类法，直到她打开了一个写着自己名字的抽屉。抽屉里的世界，是她从未做过选择的那条人生。",
    tags: ["档案", "平行世界", "选择", "奇幻"],
    featured: false,
  },
  {
    id: "t004",
    title: "春分之后",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["爱情", "都市"],
    director: "沈亦白",
    cast: ["江辰", "苏黎", "贺明"],
    duration: "全30集",
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20urban%20romance%20series%20poster%20of%20a%20city%20balcony%20at%20twilight%20with%20plants%2C%20deep%20blue%20sky%20and%20orange%20sunset%2C%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=fly-cover-012&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20modern%20city%20apartment%20balcony%20at%20twilight%20overlooking%20the%20skyline%2C%20deep%20blue%20dusk%20and%20orange%20lights%2C%20cinematic%20romance&width=1600&height=900&seq=fly-back-012&orientation=landscape",
    summary: "春分那天，他们约定各自去爱别人；春分之后，谁都没有守约。",
    synopsis:
      "建筑师江辰和花艺师苏黎在同一栋楼里住了三年，却只在天台上见过一次。春分那天，两人不约而同地来到天台，各自为即将结束的感情做最后的告别。他们订下一个约定：各自去好好爱别人，如果一年后还是单身，就在同一个地方再见。可生活从来不会按照约定走，接下来的四季里，他们经历了误解、错过、以及一次又一次没能说出口的想念。",
    tags: ["都市", "约定", "错过", "治愈"],
    featured: false,
  },
  {
    id: "t005",
    title: "双声道",
    type: "tv",
    region: "中国台湾",
    year: 2024,
    genres: ["剧情", "音乐"],
    director: "吴念川",
    cast: ["林听", "阿宽", "许雯"],
    duration: "全20集",
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20music%20drama%20series%20poster%20of%20vintage%20headphones%20and%20a%20lone%20microphone%2C%20deep%20blue%20backdrop%20with%20orange%20accent%20light%2C%20cinematic%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-013&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20dimly%20lit%20recording%20studio%20control%20room%20with%20glowing%20console%2C%20deep%20blue%20tones%20with%20orange%20indicator%20lights%2C%20cinematic%20music%20scene&width=1600&height=900&seq=fly-back-013&orientation=landscape",
    summary: "两个人的声音，一个电台的深夜时段，和一段被磁带录下的旧日时光。",
    synopsis:
      "深夜电台主持人林听的声音陪伴了无数失眠的人，却唯独没有留住自己最想留住的那个人。某天，她在整理台里的旧磁带时，听到了一段二十年前的录音——里面是两个年轻人为了一首歌争论不休的声音。她开始寻找磁带的主人，也因此重新走回了自己早就放弃的那条路。原来有些声音，只要还有人愿意听，就永远不会真正消失。",
    tags: ["电台", "音乐", "声音", "回忆"],
    featured: false,
  },
  {
    id: "t006",
    title: "午夜书店",
    type: "tv",
    region: "法国",
    year: 2025,
    genres: ["奇幻", "剧情"],
    director: "卡蜜尔·杜邦",
    cast: ["朱丽叶·莫罗", "皮埃尔·兰"],
    duration: "全10集",
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20fantasy%20series%20poster%20of%20a%20glowing%20night%20bookshop%20window%2C%20deep%20blue%20dark%20street%20with%20warm%20orange%20light%2C%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=fly-cover-014&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20charming%20old%20bookshop%20on%20a%20deep%20blue%20cobblestone%20street%20at%20midnight%2C%20warm%20orange%20window%20glow%2C%20cinematic%20fantasy%20atmosphere&width=1600&height=900&seq=fly-back-014&orientation=landscape",
    summary: "只在午夜营业的书店，卖给每个人的，都是他们真正需要的那本书。",
    synopsis:
      "巴黎一条没有名字的巷子深处，有一家只在午夜到天亮之间营业的书店。店主从不主动推荐，顾客却总能在书架深处找到一本仿佛为自己而写的书。失眠的女教师朱丽叶误打误撞走进这里，买下了一本封面空白的旧书。从翻开第一页起，她的人生开始和书里的故事悄悄重叠。她渐渐明白，这家书店真正出售的，是面对自己的勇气。",
    tags: ["书店", "午夜", "治愈", "奇幻"],
    featured: true,
  },
  {
    id: "t007",
    title: "归途列车",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["家庭", "剧情"],
    director: "冯知远",
    cast: ["古庆山", "南溪", "小满"],
    duration: "全28集",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20family%20drama%20series%20poster%20of%20a%20night%20train%20window%20with%20a%20reflection%2C%20deep%20blue%20tones%20with%20warm%20orange%20interior%20light%2C%20cinematic%20minimalist%2C%20no%20text&width=600&height=900&seq=fly-cover-015&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20long%20night%20train%20traveling%20through%20deep%20blue%20countryside%20with%20warm%20orange%20window%20lights%2C%20cinematic%20family%20drama%20landscape&width=1600&height=900&seq=fly-back-015&orientation=landscape",
    summary: "一趟跨越三千公里的绿皮火车，载着一个父亲迟到二十年的回家路。",
    synopsis:
      "老古在南方打了二十年工，攒下的钱只够买一张最慢的硬座票。他要回到三千公里外的北方老家，去看一眼已经长大的女儿。火车走走停停，车厢里挤满了和他一样赶路的人。一路上他遇到了年轻时的工友、迷路的少年、以及一个总在哭的小女孩。当他终于站在女儿面前，才发现这趟漫长归途真正要抵达的，不是某个车站，而是一句早就该说的话。",
    tags: ["归乡", "父女", "旅途", "温情"],
    featured: false,
  },
];